{
  "name": "candidate-portal",
  "version": "2.0.2",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port=4201",
    "build-dev": "ng build -c=development",
    "build-prod": "ng build -c=production",
    "build-release": "ng build -c=release",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "translate": "concurrently --kill-others \"json-server --watch src/assets/i18n/en.json --port=4000\" \"json-server --watch src/assets/i18n/sv.json --port=4001\" \"json-server --watch src/assets/i18n/no.json  --port=4002\" \"json-server --watch src/assets/i18n/fi.json  --port=4003\" \"json-server --watch src/assets/i18n/da.json  --port=4004\" \"json-server --watch src/assets/i18n/de.json  --port=4005\" "
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^17.3.11",
    "@angular/common": "^17.3.11",
    "@angular/compiler": "^17.3.11",
    "@angular/core": "^17.3.11",
    "@angular/forms": "^17.3.11",
    "@angular/platform-browser": "^17.3.11",
    "@angular/platform-browser-dynamic": "^17.3.11",
    "@angular/router": "^17.3.11",
    "@ng-select/ng-select": "^12.0.7",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "css-vars-ponyfill": "^2.4.9",
    "ngx-infinite-scroll": "^17.0.1",
    "ngx-toastr": "^19.0.0",
    "normalize.css": "^8.0.1",
    "rxjs": "^7.8.0",
    "stackblur-canvas": "^2.5.0",
    "tslib": "^2.6.3",
    "zone.js": "^0.14.7"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.3.8",
    "@angular-eslint/builder": "17.5.2",
    "@angular-eslint/eslint-plugin": "17.5.2",
    "@angular-eslint/eslint-plugin-template": "17.5.2",
    "@angular-eslint/schematics": "17.5.2",
    "@angular-eslint/template-parser": "17.5.2",
    "@angular/cli": "^17.3.8",
    "@angular/compiler-cli": "^17.3.11",
    "@angular/language-service": "^17.3.11",
    "@types/jasmine": "^5.1.4",
    "@types/jasminewd2": "^2.0.13",
    "@types/node": "^20.14.9",
    "@typescript-eslint/eslint-plugin": "^7.14.1",
    "@typescript-eslint/parser": "^7.14.1",
    "eslint": "^8.57.0",
    "jasmine-core": "^5.1.2",
    "jasmine-spec-reporter": "^7.0.0",
    "karma": "^6.4.3",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage-istanbul-reporter": "^3.0.3",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "prettier": "^3.3.2",
    "ts-node": "^10.9.2",
    "typescript": "^5.4.5"
  }
}
